import { useEffect } from "react";
import { Box, Image } from "@oneloop/jopijs";
import { useDispatch, useSelector } from "react-redux";
import style from "./contact.module.scss";
import WrapperEdition from "../../wrapperEdition/WrapperEdition";
import Trans from "@/components/shared/Trans";
import translations from "../../FichaInfo.trans.json";
import {
  setToogleEditionValue,
  setEditedData,
  setEditedDataBatch,
} from "@/store/slices/components/fichaInfo/FichaInfoSlice";
import AgentSection from "./sections/AgentSection";
import InmobiliarySection from "./sections/InmobiliarySection";
import { isTrue } from "../../utilities/helpers";
import Skeleton from "../../skelenton/Skeleton";

export default function Contact() {
  const dispatch = useDispatch();
  const state = useSelector((ste) => ste.FichaInfoSlice);
  const {
    isEdition,
    showData,
    edited_data,
    origin_data,
    loading,
    for_colleague,
    branch,
    company_logo,
    is_contact,
    from_opennavent,
  } = state;
  const { show_contact, show_agent, show_logo, show_branch } = edited_data;
  const showContactFromMail =
    show_agent ||
    show_logo ||
    show_branch ||
    isEdition ||
    !is_contact ||
    from_opennavent;

  const isDisplayable = (section) => {
    if (section.includes("agent"))
      return show_agent && isTrue(origin_data.agent_user);
    if (section.includes("logo")) return show_logo && isTrue(company_logo);
    if (section.includes("branch")) return show_branch && isTrue(branch);
    return (
      (isTrue(branch) ||
        isTrue(origin_data.agent_user) ||
        isTrue(company_logo)) &&
      showContactFromMail
    );
  };
  const visiblityAgentCompanyLogo =
    ((isDisplayable("show_agent") || isDisplayable("show_logo")) &&
      show_contact) ||
    (showData === "origin_data" && isTrue(origin_data.agent_user)) ||
    isEdition;

  const visibilityDivisorLine =
    ((isDisplayable("show_agent") && isDisplayable("show_logo")) ||
      (showData === "origin_data" &&
        isTrue(origin_data.agent_user) &&
        isTrue(company_logo))) &&
    !isEdition &&
    isTrue(state[showData].agent_user);

  const visibleSection = (section) =>
    (!isEdition && showData === "edited_data" && section && show_contact) ||
    showData === "origin_data" ||
    isEdition;

  useEffect(() => {
    if (
      isDisplayable("show_agent") ||
      isDisplayable("show_logo") ||
      isDisplayable("show_branch")
    )
      dispatch(setEditedData({ key: "show_contact", value: true }));
    else dispatch(setEditedData({ key: "show_contact", value: false }));
  }, [show_logo, show_agent, show_branch, showData, isEdition]);

  const handleContactShow = (key, show) => {
    dispatch(setToogleEditionValue(key));
    if (key === "show_contact") {
      dispatch(
        setEditedDataBatch({
          show_agent: show,
          show_logo: show,
          show_branch: show,
        })
      );
    }
  };

  if (loading)
    return (
      <Box className={style.inmoContainer}>
        <Skeleton borderRadius={16} height={191} width="100%" />
      </Box>
    );

  return (
    isDisplayable("some") &&
    !for_colleague && (
      <WrapperEdition
        eye={false}
        widthContainer="100%"
        title={Trans(translations, "ShowContactInformation")}
        enabled={show_contact}
        handleShow={(show) => handleContactShow("show_contact", show)}
        background="#F3F6F8"
        typeOfData="all-contact-information"
      >
        <Box
          data-testid="all-contact-information"
          className={`${style.inmoContainer} ${
            isEdition ? style.isEdition : ""
          }`}
        >
          {visiblityAgentCompanyLogo && (
            <Box
              className={`${style.logoAndAgentContainer} ${
                isEdition && style.isEdition
              }`}
            >
              {isTrue(company_logo) && (
                <WrapperEdition
                  width="100%"
                  marginBottom="16px"
                  padding="16px"
                  enabled={show_logo}
                  background="var(--white)"
                  handleShow={() => handleContactShow("show_logo")}
                  typeOfData="show_logo"
                >
                  {visibleSection(show_logo) && (
                    <Image
                      className={style.logoContainer}
                      src={company_logo}
                      data-testid="show_logo-card"
                      data-enabled={show_logo}
                    />
                  )}
                </WrapperEdition>
              )}
              {visibilityDivisorLine && (
                <Box width="100%" className={style.agentLogoSepareLine}>
                  -
                </Box>
              )}
              {isTrue(origin_data.agent_user) && (
                <WrapperEdition
                  width="100%"
                  marginBottom="16px"
                  gap="22px"
                  padding="16px"
                  background="var(--white)"
                  enabled={show_agent}
                  handleShow={() => handleContactShow("show_agent")}
                  typeOfData="show_agent"
                >
                  {visibleSection(show_agent) && (
                    <AgentSection enabled={show_agent} />
                  )}
                </WrapperEdition>
              )}
            </Box>
          )}
          {visibleSection(show_branch) && isTrue(branch) && (
            <Box
              className={`${style.inmoInfoContainer} ${
                isEdition && style.isEdition
              }`}
            >
              <WrapperEdition
                width="100%"
                gap="22px"
                padding="16px"
                enabled={show_branch}
                background="var(--white)"
                handleShow={() => handleContactShow("show_branch")}
                typeOfData="show_branch"
              >
                <InmobiliarySection enabled={show_branch} />
              </WrapperEdition>
            </Box>
          )}
        </Box>
      </WrapperEdition>
    )
  );
}
